/* eslint-disable no-useless-escape */
// REPORT TYPES
export const REPORT_QUALITY = 'Quality';
export const REPORT_PRODUCTION_LOG = 'ProductionLog';
export const REPORT_TECH_LOG = 'TechLog';
export const REPORT_COATING_LOG = 'CoatingProductionLog';
export const REPORT_PARTS_REQUEST = 'PartsRequest';
export const REPORT_DAMAGE = 'Damage';
/**
 * Application / integration failures; link notification emails via report_email_recipients.
 * Admin UI maps this to numeric id 10 in POST/PUT report-email-recipients payloads.
 */
export const REPORT_EMAIL_ERROR_ID = '13';

// DATE FORMATS
export const DATE = 'DD/MMM/YY';
export const DATETIMESEC = 'DD/MMM/YY, hh:mm:ss A';
export const DATETIME = 'DD-MMM-YY, hh:mm A';
export const DATETIMEFULL = 'YYYY-MM-DD hh:mm:ss';
// CREATE NEW PASSWORD
export const CHALLENGE_NAME = 'NEW_PASSWORD_REQUIRED';
// Number Pattern
export const COUNT_PATTERN = new RegExp(/^[0-9]*$/);
// Email Pattern
export const EMAIL_PATTERN = new RegExp(/\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi);
export const PASSWORD_PATTERN = new RegExp(
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,99}$/
);
// Password validation
export const PASSWORD_VALIDATION =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.[\]{}()?!"@#%&/\\,><'':;|_~`+=])[A-Za-z\d\^$*.[\]{}()?!"@#%&/\\,><'':;|_~`+=]{8,}$/;
export const TITLE = 'Password Policy';
export const PROJECTNAME_PATTERN = new RegExp(/^[^<>:"/\\|?*]+$/);
export const ENGINEER_ROLE_ID = 2;

/** Project shipment: priority sort order (lower = higher priority in list); API uses lowercase */
export const SHIPMENT_PRIORITY_RANK = { high: 0, medium: 1, low: 2 };

export const tabs = [
  { label: 'Details', value: 'details' },
  { label: 'Equipment', value: 'equipment' },
  { label: 'Spares', value: 'spares' },
  { label: 'Consumables', value: 'consumables' },
  { label: 'Material Consumption', value: 'material-consumption' },
  { label: 'Team', value: 'team' },
  { label: 'Reporting Email', value: 'reporting-email' },
  { label: 'Log', value: 'log' },
  { label: 'ITP', value: 'itp' },
  { label: 'PQT', value: 'pqt' },
  { label: 'Billing', value: 'billing' },
  { label: 'Shipment', value: 'shipment' },
  { label: 'DSR', value: 'dsr' },
  { label: 'DPR', value: 'dpr' },
  { label: 'Communications', value: 'communications' },
];
